module.exports = __webpack_public_path__ + "img/17.9f7d710c.jpg";